import styled from 'styled-components'

const SectionTitle = styled.h3`
  font-weight: 300;
  font-size: 18px;
  font-family: "Sanchez", serif;
  color: #444444;
  margin: 0;
`

export {
  SectionTitle
}